<template>
  <div 
    id="app"
    :class="(route.meta.displayMenu) ? 'd-flex' : ''"
  >
    <side-bar-nav v-if="route.meta.displayMenu"/>
    <div 
      id="view-content"
      :class="(!route.meta.displayMenu) ? 'full' : ''"
    >
      <top-bar v-if="route.meta.displayMenu"/>
      <router-view />
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { watch, onMounted } from 'vue'
import TopBar from './components/TopBar.vue'
import SideBarNav from './components/SideBarNav.vue'

export default {
  name: 'App',
  components: {
    TopBar,
    SideBarNav,
  },
  setup() {
    const route = useRoute()

    // Quando a rota mudar, logar o meta
    watch(() => route.meta, () => {
      // console.log('Meta atualizado:', meta)
    }, { immediate: true }) // O `{ immediate: true }` faz com que seja executado ao iniciar a página também

    onMounted(() => {
      console.log('Meta ao montar:', route.meta) // Pode estar vazio na recarga, mas watch capturará depois
    })

    return { route }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #ecebeb;
  width: 100vw;
  height: 100vh;
}

a {
  text-decoration: none !important;
  color: #2c3e50 !important;
}

.logged {
  display: flex;
}

#nav-bar {
  width: 15%;
  background-color: #FFFFFF;
}

#view-content {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  height: auto;
  width: 85%;
}

.full {
  width: 100% !important;
}

.click {
  cursor: pointer;
}

.card {
  border: none !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.card-header {
  background-color: none !important;
}

.card-content {
  width: 95%;
  height: fit-content !important;
  margin: 0 auto;
}

td {
  vertical-align: middle;
  /* text-align: start; */
}

.form-check-input:checked {
  background-color: red !important;
  border-color: red !important;
}

.hover {
  cursor: pointer;
}

th {
  border-left: 1px solid #2c3e50 !important;
}

th:first-child {
  border-left: none !important;
  border-top-left-radius: 8px;
}

th:last-child {
  border-top-right-radius: 8px;
}

th {
  background-color: #ecebeb !important;
  padding: 1rem !important;
  text-align: start !important;
  /* color: #2c3e50 !important; */
  font-weight: bold !important;
}

td {
  text-align: start !important;
  padding-left: 1rem !important;
}

tbody tr:last-child {
  border-style: none !important;
}

tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}

tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}

.page-link {
  color: red !important;
}

.active .page-link {
  background-color: red !important;
  border: red !important;
  color: #FFFFFF !important;
}

fieldset div {
  text-align: start;
  width: 100%;
}

#my-profile-dropdown {
  max-width: fit-content !important;
}

.add-space-on-label-btn {
  margin-right: .5rem;
}

</style>
